import { useState} from 'react';
import { cn } from '@app/shadcn/util/lib';
import { useFormState } from '@app/store/jotai/form';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useBuilderActions } from '@app/store/jotai/field-selectors';
import TabularInputField from './tabular-input-field';
import { activeFieldAtom, useActiveSlideComponent } from '@app/store/jotai/active-builder-component';
import { FieldTypes } from '@app/models/dtos/form';
import { StandardFormFieldDto } from '@app/models/dtos/form';

export default function TabularInputFieldBuilderWrapper({ field, slide }: { field: StandardFormFieldDto, slide?: number }) {
    const { t } = useTranslation('builder');
    const { theme } = useFormState();
    const { addTabularRow, addTabularColumn, updateTabularInputValue, deleteTabularRow, deleteTabularColumn } = useBuilderActions();
    const activeField = useAtomValue(activeFieldAtom);
    const { activeSlideComponent } = useActiveSlideComponent();

    const rowTitles = field?.properties?.rowTitles || [];
    const columnTitles = field?.properties?.columnTitles || [];
    const value = field?.properties?.tabular_value || [];

    const slideIndex = slide !== undefined && slide >= 0 ? slide : activeSlideComponent?.index ?? 0;

    return (
        <div className="flex flex-col gap-4">
            <div style={{ color: theme?.secondary }} className={cn('flex w-full justify-end', field.id !== activeField?.id && 'invisible')}>
                <button type="button" className="cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#123FC9]" onClick={() => addTabularColumn()}>
                    {t('CANVAS.ADD_COLUMN')}
                </button>
            </div>
            <TabularInputField
                value={value}
                onChange={(val) => updateTabularInputValue(slideIndex, field.index, val)}
                rowTitles={rowTitles}
                columnTitles={columnTitles}
                disabled
                field={field}
                onDeleteRow={(rowIndex) => deleteTabularRow(slideIndex, field.index, rowIndex)}
                onDeleteColumn={(colIndex) => deleteTabularColumn(slideIndex, field.index, colIndex)}
            />
            <div style={{ color: theme?.secondary }} className={cn('text-brand-500 flex w-full justify-start', field.id !== activeField?.id && 'invisible')}>
                <button type="button" className="cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#123FC9]" onClick={() => addTabularRow()}>
                    {t('CANVAS.ADD_ROW')}
                </button>
            </div>
        </div>
    );
}